<template>
    <div id="storedcard">
        <van-nav-bar
            title="我的储值卡"
            left-text="返回"
            left-arrow
            @click-left="clickback"/>

        <div v-if="! hasstoredvaluecard" class="emptyinfo">
            <div class="info">您尚未有储值卡...</div>
        </div>

        <van-cell-group
            v-if="hasstoredvaluecard">
            <van-cell
                :title="storedvaluecard.number"
                :value="'¥' + storedvaluecard.amount_available"/>
            <van-cell
                title="有效期"
                :value="storedvaluecard.end_date">
            </van-cell>
        </van-cell-group>
        <storedcarditems ref="items" />
    </div>
</template>

<script>
import { AssertApi } from '@/api/market'
import { Panel, NavBar, Cell, CellGroup, Tab, Tabs, Button, Divider } from 'vant'
import { toErrorPage } from '@/utils/usePage'
import storedcarditems from '@/view/user/components/storedcarditems'

export default {
    components: {
        [Panel.name]: Panel,
        [NavBar.name]: NavBar,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Button.name]: Button,
        [Divider.name]: Divider,
        storedcarditems
    },
    data() {
        return {
            hasstoredvaluecard: false,
            storedvaluecard: {
                id:null,
                number: '',
                amount_available: 0,
                begin_date: '',
                end_date: ''
            }
        }
    },
    mounted() {
        this.getAssert()
    },
    methods: {
        getAssert() {
            var that = this
            that.axios.get(AssertApi).then((ret) => {
                console.log('storevaluecard')
                console.log(ret)
                if (ret.flag) {
                    // 储值卡
                    ret = ret.details
                    if (ret.store_card) {
                        this.hasstoredvaluecard = true
                        this.storedvaluecard = {
                            id: ret.store_card? ret.store_card.id: null,
                            number: ret.store_card? ret.store_card.number: '',
                            begin_date: ret.store_card? ret.store_card.begin_date: '',
                            end_date: ret.store_card? ret.store_card.end_date: '',
                            amount_available: ret.store_card? ret.store_card.amount_available: 0
                        }
                        that.$refs.items.showdetails(ret.store_card.id)
                    } else {
                        this.hasstoredvaluecard = false
                    }
                } else {
                    toErrorPage(this,'错误',ret.info,null)
                }
            }).catch(function (error) {
                console.log(error)
            })
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/user`)
            }
        }
        // showdetails() {
        //     // this.$router.push(`/user/usehistory?style=storecard&id=${this.storedvaluecard.id}`)
        //     const path = this.$route.path.toString()
        //     if (path.indexOf('nt') > -1) {
        //         this.$router.push(`/nt/user/usehistory?style=storecard&id=${this.storedvaluecard.id}`)
        //     } else {
        //        this.$router.push(`/user/usehistory?style=storecard&id=${this.storedvaluecard.id}`)
        //     }
        // }
    }
}
</script>

<style  lang="less" scoped>
#storedcard {
    .link {
        color:  #1989fa;
    }

    .emptyinfo {
        text-align: center;

        .info {
        padding-top: 10px;
        padding-bottom: 10px;
        }

        .cmd {
        margin-top: 10px;
        color: #f44;
        }
    }
}

</style>